import React, { useState, useEffect } from "react";
import Swal from 'sweetalert2';
import { Modal, Button, Container, Row, Col } from "react-bootstrap";
import RequestServies from "../../../services/RequestServices";

function ApproveOrRejectRequisitionModal({ show, item, handleClose, onSuccess }) {
  const [errormsg, setErrormsg] = useState();
  const [previewImage, setPreviewImage] = useState("img/placeholder-img.png");

  const [formValues, setFormValues] = useState({
    inventory: item?._id,
    partNo: 0,
    requisitionNo: "",
    totalRecive: "",
    description: "",
    unit: "",
    remark: "",
    qtyAuth: 0,
    currentStock: 0,
    demand: 0,
    qtyRequired: 0,
    indigoStock: 0,
    approveQty: 0,
    user: "",
    store: "",
    image: null,
  });

  useEffect(() => {
    if (item) {
      setFormValues({
        ...formValues,
        partNo: item?.inventory?.masterItem?.partNo || 0,
        totalRecive: item?.inventory?.totalRecive || 0,
        qtyAuth: item?.inventory?.qtyAuth || 0,
        description: item?.inventory?.masterItem?.description || "",
        unit: item?.inventory?.masterItem?.unit?.name || "",
        currentStock: item?.inventory?.currentStock || 0,
        demand: item?.inventory?.qtyAuth - item?.inventory?.currentStock || 0,
        user: item?.user?.name || " ",
        store: item?.requisitionNo?.store?.name || "",
        qtyRequired: item?.qtyRequired || 0,
        requisitionNo: item?.requisitionNo?.requisitionNo || 0,
        approveQty: 0,
        adminRemark: "",
        flag:item?.flag||""
      });
      if (item?.image) {
        setPreviewImage(
          "https://indigoinfra.in/img/requisitionform/" + item?.image
        );
      }
    }
  }, [item]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
    if (name === "approveQty") {
      if (value > formValues.demand) {
        setErrormsg("Quantity required should be less than or equal to demand");
      } else {
        setErrormsg("");
      }
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues({
        ...formValues,
        image: file,
      });
    }
  };

 const handleSubmit = async (event, status) => {
  event.preventDefault();

  // Validation for approveQty
  if (!formValues.approveQty || formValues.approveQty <= 0) {
    Swal.fire({
      icon: 'error',
      title: 'Invalid Quantity',
      text: 'Approved quantity cannot be blank or zero!',
    });
    return;  // Prevent form submission if validation fails
  }

  try {
    await RequestServies.updateItem(item._id, {
      approveQty: formValues.approveQty,
      status: status,
      adminRemark: formValues.remark,
    });

    onSuccess();
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: 'Requisition form submitted successfully!',
      timer: 2000,
      showConfirmButton: false
    });
    handleClose();

  } catch (error) {
    console.error("Error while submitting requisition", error);
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'There is an input mistake. Please fill out the form carefully.',
    });
  }
};

const handleEdit = async (event) => {
  event.preventDefault();

  // Validation for qtyRequired
  if (!formValues.qtyRequired || formValues.qtyRequired <= 0) {
    Swal.fire({
      icon: 'error',
      title: 'Invalid Quantity',
      text: 'Required quantity cannot be blank or zero!',
    });
    return;  // Prevent form submission if validation fails
  }

  try {
    await RequestServies.updateItem(item._id, {
      qtyRequired: formValues.qtyRequired,
    });

    onSuccess();
    Swal.fire({
      icon: 'success',
      title: 'Updated!',
      text: 'Required Quantity has been updated successfully!',
      timer: 2000,
      showConfirmButton: false
    });
    handleClose();

  } catch (error) {
    console.error("Error while updating required quantity", error);
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'There is an input mistake. Please fill out the form carefully.',
    });
  }
};


  return (
    <Modal show={show} onHide={handleClose}>
      <form onSubmit={handleSubmit}>
        <Modal.Header>
          <Modal.Title>Requisition Form</Modal.Title>
          <Button variant="close" onClick={handleClose}></Button>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col md="6">
                <label>Part No</label>
                <input
                  type="number"
                  name="partNo"
                  className="form-control form-control-sm"
                  value={formValues.partNo}
                  readOnly
                />
              </Col>
              <Col md="6">
                <label>Description</label>
                <textarea
                  rows="1"
                  name="description"
                  className="form-control form-control-sm"
                  value={formValues.description}
                  readOnly
                />
              </Col>
              
            </Row>
            <Row>
              <Col md="6">
                <label>Unit</label>
                <input
                  type="text"
                  name="unit"
                  className="form-control form-control-sm"
                  value={formValues.unit}
                  readOnly
                />
              </Col>
              <Col md="6">
                <label>Total Auth</label>
                <input
                  type="number"
                  name="qtyAuth"
                  className="form-control form-control-sm"
                  value={formValues.qtyAuth}
                  readOnly
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <label>Total Received</label>
                <input
                  type="number"
                  name="totalRecive"
                  className="form-control form-control-sm"
                  value={formValues.totalRecive}
                  readOnly
                />
              </Col>
              <Col md="6">
                <label>Current Stock</label>
                <input
                  type="number"
                  name="currentStock"
                  className="form-control form-control-sm"
                  value={formValues.currentStock}
                  readOnly
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <label>Demand</label>
                <input
                  type="number"
                  name="demand"
                  className="form-control form-control-sm"
                  value={formValues.demand}
                  readOnly
                />
              </Col>
              <Col md="6">
                <label>Qty Required</label>
                <input
                  type="number"
                  name="qtyRequired"
                  className="form-control form-control-sm"
                  value={formValues.qtyRequired}
                   onChange={handleInputChange}   // ✅ this was missing
                />
              </Col>
              <Col md="6">
                <label>Qty Approve</label>
                <input
                  type="number"
                  name="approveQty"
                  className="form-control form-control-sm"
                  value={formValues.approveQty}
                  onChange={handleInputChange}
                />
                {errormsg && <div style={{ color: "red" }}>{errormsg}</div>}
              </Col>
              <Col md="6">
                <label>Request Status</label>
                <input
                  type="text"
                  name="approveQty"
                  className="form-control form-control-sm bg-warning"
                  value={formValues.flag}
                  readOnly
                />
            
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <label>Indigo Stock</label>
                <input
                  type="number"
                  name="indigoStock"
                  className="form-control form-control-sm"
                  value={formValues.indigoStock}
                  onChange={handleInputChange}
                />
              </Col>
              <Col md="6">
                <label>Store Keeper</label>
                <input
                  type="text"
                  name="user"
                  className="form-control form-control-sm"
                  value={formValues.user}
                  readOnly
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <label>Store</label>
                <input
                  type="text"
                  name="store"
                  className="form-control form-control-sm"
                  value={formValues.store}
                  readOnly
                />
              </Col>
              <Col md="6">
                <div className="input-field">
                  <div className="file-preview text-center">
                  <img
                    id="uploadFile"
                    src={previewImage}
                    alt="Preview"
                    className="img-fluid"
                  />
                  </div>
                  
                </div>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          
          <Button variant="primary" onClick={(event) => handleEdit(event)}>
            Edit Required Qty
          </Button>
          <Button variant="primary" onClick={(event) => handleSubmit(event, 'approvedByAdmin')}>
            Approve
          </Button>
          <Button variant="danger" onClick={(event) => handleSubmit(event, 'rejected')}>
            Reject
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default ApproveOrRejectRequisitionModal;
